import React, { Fragment, useEffect } from "react";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Form, Label, Input, Button, FormGroup, Card, CardBody, CardHeader, Badge } from "reactstrap";
import { saveProposerDetails } from "../../../../redux/bulkPolicy/action";
import BulkDocumentStepperHeader from "./bulk-document-stepper-header";

import Select from "react-select";
import RequiredIndicator from "../../../partial/RequiredIndicator";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

// import CtmInput from "./CtmInput";
import { getAllState, saveDocumentAsQuotation, stateCityByPincode, stateCityByActivePincode, validatePanCard, requestPincodeToHO, validateGstnByClearTax, stateCityByActiveMasterPincode, getClientConfig } from "../../../../api";
import { toast, ToastContainer } from "react-toastify";
import Dropzone from 'react-dropzone-uploader';
import Swal from "sweetalert2";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import PlanDetails from "./planDetails";
// import './StepStyles.scss';
import '../policy-create/StepStyles.scss'
import { getFromLocalStorage } from "../../../../hooks/useLocalStorage";
import convertToRupees from "../../../../utilities/convertToRupees";
import { t } from "i18next";
import { tr } from "date-fns/locale";
import { useNavigate, useLocation } from "react-router-dom";
import { create } from "lodash";
import { COMPANY_MASTER_PINCODE, EAI_PARTNER, SALES_MANAGER } from "../../../../constant";


const TravellerNewDetails = (props) => {
    console.log("props", props);
    const reduxValidationData = useSelector((state) => state.bulkPolicy.validationData || {});
    const reduxDiscountData = useSelector((state) => state.bulkPolicy.discountData || {});
    const reduxAddonData = useSelector((state) => state.bulkPolicy.addonData || {});
    const entireBulkPolicyState = useSelector((state) => state.bulkPolicy || {});
    const existing = reduxValidationData.successLog || {};
    const proposerUniqueNumberFromRedux = (
        reduxValidationData?.proposerCommonDetails?.proposer_unique_number ||
        reduxValidationData?.successLog?.[0]?.proposer?.proposer_unique_number ||
        ""
    );
    const proposerPassportNumberFromRedux = (
        reduxValidationData?.proposerCommonDetails?.proposer_passport_number ||
        reduxValidationData?.successLog?.[0]?.proposer?.proposer_passport_number ||
        ""
    );
    const hasProposerUniqueNumber = !!String(proposerUniqueNumberFromRedux).trim();
    const updatedBulkTotalPremium = reduxDiscountData?.discountedRecords?.length > 0
        ? reduxDiscountData.discountedRecords.reduce((sum, r) => sum + (r.discount?.premiumAfterDiscount || 0), 0)
        : (reduxValidationData?.successLog || []).reduce((sum, record) => {
            const recordId = record.id || record.proposer?.proposer_id || record.record_index;
            const basePremium = Number(record?.documentDetails?.base_premium || 0);
            const addonPremium = Number(reduxAddonData?.additionalCost?.[recordId] || record?.documentDetails?.addons_premium || 0);
            const subtotal = basePremium + addonPremium;
            return sum + subtotal + (subtotal * 0.18);
        }, 0) || reduxValidationData?.totalPremium || 0;
    console.log("reduxValidationData traveller details", reduxValidationData.successLog[0]);
    const relationOptions = [
        { value: 'FATHER', label: 'Father' },
        { value: 'MOTHER', label: 'Mother' },
        { value: 'SPOUSE', label: 'Spouse' },
        { value: 'SELF', label: 'Self' },

    ];

    const policyData = useSelector((content) => content.bulkPolicy);
    const companyId = policyData?.generateQuote?.company_id;
    const schema = yup.object().shape({
        // Proposer Personal Information
        proposer_passport_number: hasProposerUniqueNumber
            ? yup.string().notRequired()
            : yup.string()
                .required("Passport is required")
                .matches(/^[A-Z0-9]{8,9}$/, "Invalid passport number. Must be 8-9 characters (uppercase letters and numbers only)"),
        proposer_dob: yup.string().required("DOB is required"),
        proposer_gender: yup.string().required("Gender is required"),
        proposer_title: yup.string().required("Title is required"),
        proposer_first_name: yup.string().required("First name is required")
            .matches(/^[a-zA-Z\s]+$/, "Only letters and spaces allowed"),
        proposer_middle_name: yup.string().notRequired()
            .matches(/^[a-zA-Z\s]*$/, "Only letters and spaces allowed"),
        proposer_last_name: yup.string().required("Last name is required")
            .matches(/^[a-zA-Z\s]+$/, "Only letters and spaces allowed"),
        // Address Information
        proposer_pin_code: yup.string().required("Pin code is required").length(6, "Pin Code should be 6 digits"),
        proposer_address: yup.string().required("Address is required").max(100, "Address cannot be more than 100 characters"),
        proposer_email: yup.string().required("Email is required")
            .matches(/^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,4}$/, "Email is invalid"),
        proposer_mobile: yup.string().required("Mobile is required")
            .matches(/^\d{10}$/, "Only numbers allowed").length(10, "Mobile Number should be 10 digits"),
       city: yup.object()
        .shape({       
            value: yup.mixed().test('valid-city', 'City is required', function(value) {
                return value !== 0 && value !== "" && value != null;
            }),
            label: yup.string().test('valid-city-label', 'City is required', function (value) {
                return value !== "No city found" && value !== "Loading..." && value !== "Invalid data" && value !== "Select City" && value !== "";
            })
        }).test(
            "city-selected",
            "City is required",
            (value) => value && value.value !== 0
        ).required("City is required"),
        state: yup.object()
            .shape({
                value: yup.mixed().test('valid-state', 'State is required', function (value) {
                    return value !== 0 && value !== "" && value != null;
                }),
            label: yup.string().test('valid-state-label', 'State is required', function(value) {
                return value !== "No state found" && value !== "Loading..." && value !== "Invalid data" && value !== "";
            })
        })
        .required("State is required"),
        isGSTN: yup.boolean().optional(),
        customer_gstn: yup.string().when('isGSTN' ,{
            is: (isGSTN) => isGSTN === true,
            then: (schema) => schema.required("GSTN Number is required"),
            otherwise: (schema) => schema
        }),
        customer_company_name: yup.string().when('isGSTN' ,{
            is: (isGSTN) => isGSTN === true,
            then: (schema) => schema.required("Comapny is required"),
            otherwise: (schema) => schema
        }),
        customer_company_address: yup.string().when('isGSTN' ,{
            is: (isGSTN) => isGSTN === true,
            then: (schema) => schema
                .required("Company address is required")
                .test(
                    'customer-company-address-words',
                    'Company address must be between 3 and 100 words',
                    function (value) {
                        if (!value) return true; // let 'required' handle empty
                        const words = value;
                        return words.length >= 3 && words.length <= 100;
                    }
                ),
            otherwise: (schema) => schema
        }),
        customer_company_pin_code: yup.string().when('isGSTN' ,{
            is: (isGSTN) => isGSTN === true,
            then: (schema) => schema.required("Company Pincode is required"),
            otherwise: (schema) => schema
        }),
        customer_email: yup.string().when('isGSTN' ,{
            is: (isGSTN) => isGSTN === true,
            then: (schema) => schema.required("Email is required").matches(/^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,4}$/, "Email is invalid"),
            otherwise: (schema) => schema
        }),
        customer_mobile: yup.string().when('isGSTN' ,{
            is: (isGSTN) => isGSTN === true,
            then: (schema) => schema.required("Mobile is required").matches(/^\d{10}$/, "Only numbers allowed").length(10, "Mobile Number should be 10 digits"),
            otherwise: (schema) => schema
        }),   
        proposer_pan: yup.string().notRequired(),

    });
    const {
        handleSubmit,
        register,
        setValue,
        trigger,
        getValues,
        formState,
        formState: { errors },
        watch,
        clearErrors,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            country: "India",
            proposer_pan:"AABCE7775Q"
        },
        mode: 'onSubmit',
    });
    // Ensure RHF knows about these programmatically-managed fields so they appear in submit data
    useEffect(() => {
        if (typeof register === 'function') {
            register('isCustomerInvoice');
            register('isGSTN');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { onBack, activeStep, setActiveStep, setStep2Valid, gstnStateCode, setGstnStateCode } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [isLoading, setIsLoading] = useState(false);
    const [defaultCountry, setDefaultCountry] = useState("India");
    const [stateList, setStateList] = useState([]);
    const [stateDetails, setStateDetails] = useState({});
    const [cityDetails, setCityDetails] = useState({});
    // company-specific location state (for GST customer/company fields)
    const [companyStateDetails, setCompanyStateDetails] = useState({});
    const [companyCityDetails, setCompanyCityDetails] = useState({});
    // const [panVerifiedDealerName, setPanVerifiedDealerName] = useState("");
    const [proposerFullName, setProposerFullName] = useState("");
    const [quotationNumber, setQuotationNumber] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const [isGstDetails, setGstDetails] = useState(false);
    const [isCustomerInvoice, setCustomerInvoice] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState("");
    console.log("selectCompany", selectedCompany);
    // ref used to debounce GST lookup
    const gstLookupTimeout = useRef(null);
    const ROLE = JSON.parse(localStorage.getItem("ROLE"));
    const role_key = ROLE?.key;
    const location = useLocation();
    const [cityOptions, setCityOptions]= useState(null);
    const user = role_key == SALES_MANAGER ? location?.state?.user : getFromLocalStorage("user");
    console.log("user?.partnerInfo.user.is_gst_registered------->", user?.partnerInfo?.user);
    const isGSTReg= role_key == SALES_MANAGER ? location?.state?.user?.partnerInfo?.partnerInfo?.user?.is_gst_registered ? true : false : user?.partnerInfo?.user.is_gst_registered ? true : false
    console.log("location?.state?.user------->", location?.state);
    console.log("isGSTReg------->", isGSTReg);
    const [isTataAigCompany, setIsTataAigCompany] = useState(false);
    const partnershipType = role_key == SALES_MANAGER ? location?.state?.user?.partnerInfo?.partnerInfo?.type : getFromLocalStorage('user')?.partnerInfo?.type;
    console.log("partnershipTypeeee", partnershipType);

    const role_id= ROLE?.role_id ? ROLE.role_id : '';
    const role_name = ROLE?.name ? ROLE.name : '';
    // Set default invoice selection: if GST-registered, default to Invoice To Self
    const isRo = role_id == 47 || role_key?.toUpperCase() === 'RO' || partnershipType?.toUpperCase() === 'RO' || role_name?.toUpperCase()?.includes('REGIONAL') || role_key?.toUpperCase()?.includes('REGIONAL');
    useEffect(() => {
         if (isGSTReg) {
            if (isRo) {
                setCustomerInvoice(true);
                setValue('isCustomerInvoice', true);
            } else {
                // Invoice To Self => isCustomerInvoice should be false
                setCustomerInvoice(false);
                setValue('isCustomerInvoice', false);
            }
        }
       
        // Leave non-GST behavior and other flags as-is
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isGSTReg, isRo]);
    
        console.log("tataaig company", isTataAigCompany);
        
        useEffect(() => {
        const companyId = watch('company_id');
        const isTataAig = Number(companyId) === 376;
        console.log("isTataAig------->", isTataAig);
        
        setIsTataAigCompany(isTataAig);
    }, [watch('company_id')]);


    console.log("props.quotationId",props);
    
    
    const [step, setStep] = useState(1);
    
    // Proposer personal information state
    const [proposerOCI, setProposerOCI] = useState({ isOci: false, oci_file: null, oci_file_path: null, oci_file_name: '' });
    const [passportNo, setPassportNo] = useState('');
    const [proposerDob, setProposerDob] = useState('');
    const [proposerGender, setproposerGender] = useState('');
    const [proposerTitle, setProposerTitle] = useState('');
    const [proposerFName, setProposerFName] = useState('');
    const [proposerMName, setProposerMName] = useState('');
    const [proposerLName, setProposerLName] = useState('');

    const handleBackClick = () => {
        if (onBack) {
            onBack(); // Call the onBack prop to navigate back
        } else if (step > 1) {
            setStep(step - 1);
        }
    };


    const fetchCompanyGst = async (gstin) => {
        // simulate latency and return the fake response
        const data = { gstNumber: gstin }
        const gstinDetails = await validateGstnByClearTax(data);
        const GstData = gstinDetails?.data?.result?.msg;
        console.log(GstData.taxpayerInfo, "GstData");
        return new Promise((resolve) => {
            setTimeout(() => resolve(GstData), 250);
        });
    };

    const handleNextClick = () => {
        setStep(step + 1);
    };

    useEffect(() => {
        // setQuotationNumber(`${Date.now()}`);
        setQuotationNumber("");
        fetchStateDetails("101")
    }, []);

    // Removed - we don't read from successLog anymore, only from proposerCommonDetails

    const fetchStateDetails = async (country_id) => {
        await getAllState(country_id)
            .then((res) => {
                const stateData = res.data?.result;
                const formatData = stateData?.map((item) => {
                    return {
                        value: item.state_id,
                        label: item.name,
                    };
                });
                formatData.unshift({
                    value: "",
                    label: "Select Province/State",
                    disabled: true,
                });
                setStateList(formatData);
            })
            .catch((err) => { });
    };

const handleRequestPincodeToHO = async (pincode) => {
    try {
        setIsLoading(true);
        
        const requestData = {
            pincode: pincode,
            message: `Request to add pincode ${pincode} to the system`,
            timestamp: new Date().toISOString(),
            user_email: reduxValidationData?.proposerCommonDetails?.proposer_email || getValues()['proposer_email'] || 'Unknown',
            user_name: proposerFullName || 'Unknown User',
            quotation_number: quotationNumber
        };
        
        // Use actual API call
        const response = await requestPincodeToHO(requestData);
        console.log(response, 'requestPincodeToHO response');
        
        // Show success message
        toast.success(`Request for pincode ${pincode} has been sent to Head Office successfully!`);
        
    } catch (error) {
        console.error('Error requesting pincode to HO:', error);
        toast.error('Failed to send request to Head Office. Please try again.');
    } finally {
        setIsLoading(false);
    }
};
    // Removed - we only populate from proposerCommonDetails, not from successLog

    // cleanup debounce timer on unmount
    useEffect(() => {
        return () => {
            if (gstLookupTimeout.current) {
                clearTimeout(gstLookupTimeout.current);
                gstLookupTimeout.current = null;
            }
        };
    }, []);

    // Removed - we don't use successLog for conditional GST field population

    // Log Redux state whenever proposerCommonDetails changes
    useEffect(() => {
        if (reduxValidationData?.proposerCommonDetails) {
            console.log('=== REDUX PROPOSER COMMON DETAILS UPDATED ===');
            console.log('Proposer Common Details from Redux:', reduxValidationData.proposerCommonDetails);
        }
    }, [reduxValidationData?.proposerCommonDetails]);

    // Populate form with saved proposer details from Redux when component mounts or data changes
    useEffect(() => {
        const savedData = reduxValidationData?.proposerCommonDetails;
        console.log('🔄 Checking for saved proposer details...');
        console.log('📦 proposerCommonDetails from Redux:', savedData);
        console.log('📊 Keys in proposerCommonDetails:', savedData ? Object.keys(savedData) : 'NO DATA');
        
        if (savedData && Object.keys(savedData).length > 0) {
            console.log('✅ Found saved data, starting repopulation...');
            
            // Populate personal information fields
            const proposerIdentity = savedData.proposer_unique_number || savedData.proposer_passport_number;
            if (proposerIdentity) {
                setPassportNo(proposerIdentity);
                setValue('proposer_passport_number', proposerIdentity);
            }
            if (savedData.proposer_dob) {
                setProposerDob(savedData.proposer_dob);
                setValue('proposer_dob', savedData.proposer_dob);
            }
            if (savedData.proposer_gender) {
                setproposerGender(savedData.proposer_gender);
                setValue('proposer_gender', savedData.proposer_gender);
            }
            if (savedData.proposer_title) {
                setProposerTitle(savedData.proposer_title);
                setValue('proposer_title', savedData.proposer_title);
            }
            if (savedData.proposer_first_name) {
                setProposerFName(savedData.proposer_first_name);
                setValue('proposer_first_name', savedData.proposer_first_name);
            }
            if (savedData.proposer_middle_name !== undefined) {
                setProposerMName(savedData.proposer_middle_name);
                setValue('proposer_middle_name', savedData.proposer_middle_name);
            }
            if (savedData.proposer_last_name) {
                setProposerLName(savedData.proposer_last_name);
                setValue('proposer_last_name', savedData.proposer_last_name);
            }
            
            // Populate all text fields
            if (savedData.proposer_pin_code) {
                setValue('proposer_pin_code', savedData.proposer_pin_code);
                // Fetch state/city if pincode is valid
                if (savedData.proposer_pin_code.toString().length === 6) {
                    fetchPincodeDetails(savedData.proposer_pin_code);
                }
            }
            if (savedData.proposer_address) setValue('proposer_address', savedData.proposer_address);
            if (savedData.proposer_email) setValue('proposer_email', savedData.proposer_email);
            if (savedData.proposer_mobile) setValue('proposer_mobile', savedData.proposer_mobile);
            if (savedData.proposer_pan) setValue('proposer_pan', savedData.proposer_pan);
            if (savedData.proposer_country) setValue('proposer_country', savedData.proposer_country);
            
            // Populate state and city (these are Select components with value/label format)
            if (savedData.state) {
                setValue('state', savedData.state);
                setStateDetails(savedData.state);
            }
            if (savedData.city) {
                setValue('city', savedData.city);
                setCityDetails(savedData.city);
            }
            
            // Populate GST/Invoice flags and fields
            if (savedData.isCustomerInvoice !== undefined) {
                const invoiceVal = (isGSTReg && isRo) ? true : savedData.isCustomerInvoice;
                console.log('🔄 Restoring isCustomerInvoice:', invoiceVal);
                setValue('isCustomerInvoice', invoiceVal);
                setCustomerInvoice(invoiceVal);
            }
            if (savedData.isGSTN !== undefined) {
                console.log('🔄 Restoring isGSTN:', savedData.isGSTN);
                setValue('isGSTN', savedData.isGSTN);
                setGstDetails(savedData.isGSTN);
            }
            
            // IMPORTANT: Use setTimeout to ensure GST fields are rendered before we try to populate them
            // This allows React to re-render after setGstDetails(true) so the fields exist in the DOM
            setTimeout(() => {
                console.log('🔄 Restoring GST fields (after render):', {
                    customer_email: savedData.customer_email,
                    customer_mobile: savedData.customer_mobile,
                    customer_gstn: savedData.customer_gstn,
                    customer_company_name: savedData.customer_company_name,
                    customer_company_address: savedData.customer_company_address,
                    customer_company_pin_code: savedData.customer_company_pin_code,
                    customer_company_state: savedData.customer_company_state,
                    customer_company_city: savedData.customer_company_city
                });
                
                if (savedData.customer_email) setValue('customer_email', savedData.customer_email);
                if (savedData.customer_mobile) setValue('customer_mobile', savedData.customer_mobile);
                if (savedData.customer_gstn) {
                    setValue('customer_gstn', savedData.customer_gstn);
                }
                if (savedData.customer_company_pin_code) {
                    setValue('customer_company_pin_code', savedData.customer_company_pin_code);
                    // Fetch company state/city if company pincode is valid
                    if (savedData.customer_company_pin_code.toString().length === 6) {
                        fetchCompanyPincodeDetails(savedData.customer_company_pin_code);
                    }
                }
                if (savedData.customer_company_name) setValue('customer_company_name', savedData.customer_company_name);
                if (savedData.customer_company_address) setValue('customer_company_address', savedData.customer_company_address);
                
                console.log('✅ GST fields restored!');
            }, 50); // Small delay to allow React to render the fields first
            
            // Populate company state and city
            if (savedData.customer_company_state) {
                setValue('customer_company_state', savedData.customer_company_state);
                setCompanyStateDetails(savedData.customer_company_state);
            }
            if (savedData.customer_company_city) {
                setValue('customer_company_city', savedData.customer_company_city);
                setCompanyCityDetails(savedData.customer_company_city);
            }
            
            console.log('✅ Form repopulated with saved data');
        }
    }, [reduxValidationData?.proposerCommonDetails]);

    useEffect(() => {
        const proposerDetails = reduxValidationData?.proposerCommonDetails;
        if (proposerDetails && proposerDetails.proposer_first_name && proposerDetails.proposer_last_name) {
            const proposerName = `${proposerDetails.proposer_title || ''} ${proposerDetails.proposer_first_name} ${proposerDetails.proposer_last_name}`.trim();
            setProposerFullName(proposerName);
        }
    }, [reduxValidationData?.proposerCommonDetails]);

    useEffect(() => {
        if (!passportNo) {
            if (hasProposerUniqueNumber) {
                setPassportNo(proposerUniqueNumberFromRedux);
                setValue('proposer_passport_number', proposerUniqueNumberFromRedux);
            } else if (proposerPassportNumberFromRedux) {
                setPassportNo(proposerPassportNumberFromRedux);
                setValue('proposer_passport_number', proposerPassportNumberFromRedux);
            }
        }
    }, [hasProposerUniqueNumber, passportNo, proposerUniqueNumberFromRedux, proposerPassportNumberFromRedux, setValue]);


    const handleTravellerDetails = async (data) => {
        console.log(data, "data11222")
        
        const isFormValid = await trigger();
        if (!isFormValid) {
            console.error('Form validation failed');
            return;
        }
        
        // Get all current form values
        const formVals = getValues();
        
        const isDomesticGeo = String(
            reduxValidationData?.successLog?.[0]?.documentDetails?.geographical_cover_name || 
            reduxValidationData?.successLog?.[0]?.geographical_cover_name || 
            ''
        ).toLowerCase().trim() === 'domestic' || 
        reduxValidationData?.successLog?.[0]?.geographical_cover_id === 11 || 
        reduxValidationData?.successLog?.[0]?.geographical_cover_id === 17;

        console.log('📝 All form values from getValues():', formVals);
        console.log('🏢 State variables for GST:', {
            isGstDetails,
            companyStateDetails,
            companyCityDetails
        });
        
        // Build complete proposer details object with all fields
        const proposerDetails = {
            // Only keep successLog data that's not form-related (like company_id, type_id, etc.)
            ...reduxValidationData?.successLog[0]?.proposer,
            
            // Personal Information
            proposer_passport_number: isDomesticGeo ? '' : (passportNo || ''),
            proposer_unique_number: hasProposerUniqueNumber ? proposerUniqueNumberFromRedux : (passportNo || ''),
            proposer_dob: proposerDob || '',
            proposer_gender: proposerGender || '',
            proposer_title: proposerTitle || '',
            proposer_first_name: proposerFName || '',
            proposer_middle_name: proposerMName || '',
            proposer_last_name: proposerLName || '',
            
            // Address Information
            proposer_pin_code: data?.proposer_pin_code || '',
            proposer_address: data?.proposer_address || '',
            proposer_email: data?.proposer_email || '',
            proposer_mobile: data?.proposer_mobile || '',
            proposer_pan: data?.proposer_pan || 'AABCE7775Q',
            proposer_country: data?.proposer_country || 'India',
            state: data?.state || stateDetails,
            city: data?.city || cityDetails,
            
            // Invoice Flags (critical - must be saved!)
            isCustomerInvoice: typeof formVals.isCustomerInvoice === 'boolean' 
                ? formVals.isCustomerInvoice 
                : isCustomerInvoice,
            isGSTN: typeof formVals.isGSTN === 'boolean' 
                ? formVals.isGSTN 
                : isGstDetails,
            
            // Customer GST Details (only save if GST is enabled, otherwise preserve existing or use empty)
            // Use formVals if available, otherwise fall back to existing Redux data
            customer_email: isGstDetails 
                ? (formVals.customer_email !== undefined ? formVals.customer_email : (reduxValidationData?.proposerCommonDetails?.customer_email || ''))
                : (reduxValidationData?.proposerCommonDetails?.customer_email || ''),
            customer_mobile: isGstDetails 
                ? (formVals.customer_mobile !== undefined ? formVals.customer_mobile : (reduxValidationData?.proposerCommonDetails?.customer_mobile || ''))
                : (reduxValidationData?.proposerCommonDetails?.customer_mobile || ''),
            customer_gstn: isGstDetails 
                ? (formVals.customer_gstn !== undefined ? formVals.customer_gstn : (reduxValidationData?.proposerCommonDetails?.customer_gstn || ''))
                : (reduxValidationData?.proposerCommonDetails?.customer_gstn || ''),
            customer_company_name: isGstDetails 
                ? (formVals.customer_company_name !== undefined ? formVals.customer_company_name : (reduxValidationData?.proposerCommonDetails?.customer_company_name || ''))
                : (reduxValidationData?.proposerCommonDetails?.customer_company_name || ''),
            customer_company_address: isGstDetails 
                ? (formVals.customer_company_address !== undefined ? formVals.customer_company_address : (reduxValidationData?.proposerCommonDetails?.customer_company_address || ''))
                : (reduxValidationData?.proposerCommonDetails?.customer_company_address || ''),
            customer_company_pin_code: isGstDetails 
                ? (formVals.customer_company_pin_code !== undefined ? formVals.customer_company_pin_code : (reduxValidationData?.proposerCommonDetails?.customer_company_pin_code || ''))
                : (reduxValidationData?.proposerCommonDetails?.customer_company_pin_code || ''),
            customer_company_state: isGstDetails 
                ? (Object.keys(companyStateDetails).length > 0 ? companyStateDetails : (formVals.customer_company_state || reduxValidationData?.proposerCommonDetails?.customer_company_state || {}))
                : (reduxValidationData?.proposerCommonDetails?.customer_company_state || {}),
            customer_company_city: isGstDetails 
                ? (Object.keys(companyCityDetails).length > 0 ? companyCityDetails : (formVals.customer_company_city || reduxValidationData?.proposerCommonDetails?.customer_company_city || {}))
                : (reduxValidationData?.proposerCommonDetails?.customer_company_city || {}),
            
            quotation_number: quotationNumber.length > 0 ? quotationNumber : "",
        };
        
        console.log('=== PROPOSER DETAILS BEING SAVED TO REDUX ===');
        console.log('Form Data:', data);
        console.log('Form Values:', formVals);
        console.log('State Variables:', {
            isGstDetails,
            isCustomerInvoice,
            companyStateDetails,
            companyCityDetails,
            stateDetails,
            cityDetails
        });
        console.log('GST Fields from formVals:', {
            customer_email: formVals.customer_email,
            customer_mobile: formVals.customer_mobile,
            customer_gstn: formVals.customer_gstn,
            customer_company_name: formVals.customer_company_name,
            customer_company_address: formVals.customer_company_address,
            customer_company_pin_code: formVals.customer_company_pin_code,
            customer_company_state: formVals.customer_company_state,
            customer_company_city: formVals.customer_company_city
        });
        console.log('📋 FINAL proposerDetails object to be dispatched:', proposerDetails);
        console.log('🔑 Customer GST fields in final object:', {
            customer_email: proposerDetails.customer_email,
            customer_mobile: proposerDetails.customer_mobile,
            customer_gstn: proposerDetails.customer_gstn,
            customer_company_name: proposerDetails.customer_company_name,
            customer_company_address: proposerDetails.customer_company_address,
            customer_company_pin_code: proposerDetails.customer_company_pin_code,
        });
        console.log('Checkboxes State:', {
            isCustomerInvoice,
            isGstDetails,
            formIsCustomerInvoice: formVals.isCustomerInvoice,
            formIsGSTN: formVals.isGSTN
        });
        
        // Save proposer details to Redux
        dispatch(saveProposerDetails(proposerDetails));
        
        console.log('✅ Proposer details dispatched to Redux!');
        console.log('📋 Saved at path: state.bulkPolicy.validationData.proposerCommonDetails');
        console.log('📦 Dispatched payload:', JSON.stringify(proposerDetails, null, 2));
        
        // Verify Redux state after dispatch
        setTimeout(() => {
            const currentReduxState = reduxValidationData;
            console.log('🔍 Redux state after dispatch:', currentReduxState?.proposerCommonDetails);
            console.log('🔍 Customer GST fields in Redux:', {
                customer_email: currentReduxState?.proposerCommonDetails?.customer_email,
                customer_mobile: currentReduxState?.proposerCommonDetails?.customer_mobile,
                customer_gstn: currentReduxState?.proposerCommonDetails?.customer_gstn,
                customer_company_name: currentReduxState?.proposerCommonDetails?.customer_company_name,
                customer_company_address: currentReduxState?.proposerCommonDetails?.customer_company_address,
                customer_company_pin_code: currentReduxState?.proposerCommonDetails?.customer_company_pin_code,
            });
        }, 100);
        
        // Show success message
        toast.success("Proposer details saved successfully!");
        
        // Navigate to payment page
        setTimeout(() => {
            navigate('/documents/bulk/payment',{state:{user:user}});
        }, 1500);
    };

    // const handleSave = async (updatedPolicyData) => {
    //         try {
    //             console.log(updatedPolicyData, 'updatedPolicyData123 traveller...............!!!!!!!!!!');
    //             const formData = {};
    //             const generateQuoteDetails = updatedPolicyData?.generateQuote;
    //             const proposerData = updatedPolicyData?.travellerDetails;
    //             formData["type_id"] = generateQuoteDetails?.policyType;
    //             formData["geographical_cover_id"] = generateQuoteDetails?.geographicalCoverId;
    //             formData["geographical_cover_name"] = policyData.generateQuote?.policyData?.generateQuote?.geographical_cover;
    //             // if (props.quotationId) {
    //                 formData["quotation_number"] =  policyData.generateQuote?.quotation_number; 
    //             // }else{
    //             //     formData["quotation_number"] =  '';
    //             // }
                
    //             const proposerDetails = {
    //                 proposer_passport_number: generateQuoteDetails?.proposer_passport_number,
    //                 proposer_unique_number:  generateQuoteDetails?.proposer_unique_number,
    //                 proposer_gender: generateQuoteDetails?.proposer_gender,
    //                 proposer_dob: generateQuoteDetails?.proposer_dob,
    //                 proposer_title: generateQuoteDetails?.proposer_title,
    //                 proposer_first_name: generateQuoteDetails?.proposer_first_name,
    //                 proposer_middle_name: generateQuoteDetails?.proposer_middle_name,
    //                 proposer_last_name: generateQuoteDetails?.proposer_last_name,
    //                 number_of_travel_days: generateQuoteDetails?.noOfDays,
    //                 proposer_pin_code: proposerData?.proposer_pin_code,
    //                 proposer_address: proposerData?.proposer_address,
    //                 // Normalize flags per rules: non-GST partners must invoice to customer
    //                 isCustomerInvoice: !isGSTReg ? true : proposerData?.isCustomerInvoice,
    //                 isGSTN: proposerData?.isGSTN,
    //                 proposer_email: proposerData?.proposer_email,
    //                 proposer_mobile: proposerData?.proposer_mobile,
    //                 state: proposerData?.state?.label,
    //                // proposer_country:generateQuoteDetails?.geo_country?.value || null,
    //                 city: proposerData?.city?.label,
    //                 proposer_pan:proposerData?.proposer_pan || "AABCE7775Q",
    //                 proposer_oci:generateQuoteDetails?.proposer_oci || false,
    //                 proposer_oci_file_path:generateQuoteDetails?.proposer_oci_file_path || null
    //             }
    //             formData["proposer"] = proposerDetails;

    //             const geoCountryValues = [];
    //             if (generateQuoteDetails?.geo_country) {
    //                 const geo_country = generateQuoteDetails?.geo_country;
    //                 geoCountryValues.push(...geo_country.map(item => item.value));
    //             }

    //            const documentDetails = {
    //             geo_country: geoCountryValues,
    //             travel_start_date: generateQuoteDetails?.startDate,
    //             travel_end_date: generateQuoteDetails?.endDate,
    //             number_of_travel_days: generateQuoteDetails?.noOfDays,
    //             plan_id: generateQuoteDetails?.plan_id,
    //             member_premium: generateQuoteDetails?.pricing_member_premium || generateQuoteDetails?.plan_cost,
    //             member_coverage: generateQuoteDetails?.plan_cover || 0,
    //             quotation_number: policyData.generateQuote?.quotation_number || '',
    //             base_premium: generateQuoteDetails?.plan_basic_cost,
    //             addons_premium:  Number(policyData.generateQuote?.pricing_new_addons_premium || policyData.generateQuote?.addonCost || 0),
    //             company_id: generateQuoteDetails?.company_id,
    //             partnership_id: role_key == SALES_MANAGER ? generateQuoteDetails?.partnership_id ? Number(generateQuoteDetails?.partnership_id) : user?.partnerInfo?.partnership_id : null,
    //             created_by_role_id: generateQuoteDetails?.created_by_role_id ? Number(generateQuoteDetails?.created_by_role_id) : role_id || null,
    //             created_by_role: generateQuoteDetails?.created_by_role ? generateQuoteDetails?.created_by_role : role_name || null,
    //             customer_email: proposerData?.customer_email,
    //             customer_mobile: proposerData?.customer_mobile,
    //             customer_gstn: proposerData?.customer_gstn,
    //             // Normalize flags per rules: non-GST partners must invoice to customer
    //             isCustomerInvoice: !isGSTReg ? true : proposerData?.isCustomerInvoice,
    //             // use company-specific state/city/pincode when GST is enabled
    //             customer_company_state: proposerData?.isGSTN ? proposerData?.customer_company_state?.label || '' : '',
    //             customer_company_city: proposerData?.isGSTN ? proposerData?.customer_company_city?.label || '' : '',
    //             customer_company_pincode: proposerData?.isGSTN ? proposerData?.customer_company_pin_code || null : null,
    //             isGSTN: proposerData?.isGSTN,
    //             customer_company_name: proposerData?.customer_company_name,
    //             customer_company_address: proposerData?.customer_company_address,
    //             customer_company_pin_code: proposerData?.customer_company_pin_code,
    //             from_state :  generateQuoteDetails?.from_state?.value,
    //             from_city :  generateQuoteDetails?.from_city?.value,
    //             to_state :  generateQuoteDetails?.to_state?.value,
    //             to_city :  generateQuoteDetails?.to_city?.value,
    //             pricing_base_premium: Number(policyData.generateQuote?.pricing_base_premium || policyData.generateQuote?.plan_basic_cost),
    //             pricing_addons_premium: Number(policyData.generateQuote?.pricing_addons_premium || policyData.generateQuote?.addonCost),
    //             pricing_msc_percent: Number(policyData.generateQuote?.pricing_msc_percent),
    //             pricing_msc_amount: Number(policyData.generateQuote?.pricing_msc_amount),
    //             pricing_discount_percent: Number(policyData.generateQuote?.pricing_discount_percent),
    //             pricing_discount_amount: Number(policyData.generateQuote?.pricing_discount_amount),
    //             pricing_new_base_premium: Number(policyData.generateQuote?.pricing_new_base_premium || policyData.generateQuote?.plan_basic_cost),
    //             pricing_new_addons_premium: Number(policyData.generateQuote?.pricing_new_addons_premium || policyData.generateQuote?.addonCost || 0),
    //             pricing_total_premium: Number(policyData.generateQuote?.pricing_total_premium),
    //             pricing_gst_percent: Number(policyData.generateQuote?.pricing_gst_percent),
    //             pricing_gst_amount: Number(policyData.generateQuote?.pricing_gst_amount),
    //             pricing_member_premium: Number(policyData.generateQuote?.pricing_member_premium || policyData.generateQuote?.plan_cost),
    //         }
    //             formData["documentDetails"] = documentDetails;

    //             const travellersData = generateQuoteDetails?.travellers || [];
    //             formData["travellers"] = travellersData.map((traveller, index) => ({
    //                 traveller_passport: traveller.traveller_passport_number || "",
    //                 traveller_unique_number:  traveller.traveller_unique_number || '' ,
    //                 traveller_dob: traveller.traveller_dob || "",
    //                 title: traveller.title || "",
    //                 firstName: traveller.firstName || "",
    //                 middleName: traveller.middleName || "",
    //                 lastName: traveller.lastName || "",
    //                 gender: traveller.gender || "",
    //                 critical_illness: traveller.critical_illness || "",
    //                 pre_reduxValidationData_disease: traveller.pre_reduxValidationData_disease || "",
    //                 suffering_since: traveller.suffering_since || "",
    //                 ped_type: traveller.ped_type || "",
    //                 under_medication: traveller.under_medication || "",
    //                 trip_duration: Number(traveller.trip_duration) || 0,
    //                 plan_id: generateQuoteDetails?.plan_id,
    //                 base_coi: generateQuoteDetails?.plan_coi || 0,
    //                 addons_coi: generateQuoteDetails?.addons_coi || 0,
    //                 same_as_proposer: generateQuoteDetails?.same_as_proposer,
    //                 member_premium: generateQuoteDetails?.plan_cost || 0,
    //                 member_coverage: generateQuoteDetails?.plan_cover || 0,
    //                 addons: generateQuoteDetails?.addons,
    //                 addons_premium: generateQuoteDetails?.addonCost || 0,
    //                 isOci: traveller.isOci || false,
    //                 oci_file_path: traveller.oci_file_path || null,
    //             }));

    //             const nomineeData = generateQuoteDetails?.nominee || [];
    //             console.log("nomineeDataaaaaaaaaa", nomineeData);
                
    //             formData["nominees"] = nomineeData.map((nominee, index) => ({
    //                 nominee_dob: nominee.nominee_dob || "",
    //                 nominee_title: nominee.title || "",
    //                 nominee_firstName: nominee.firstName || "",
    //                 nominee_middleName: nominee.middleName || "",
    //                 nominee_lastName: nominee.lastName || "",
    //                 // nominee_relation: nominee.nomineeRelation || "",
    //                 nominee_relation: nominee.nominee_relation || ""
    //             }));
    
    //             console.log(formData,'formData inside proposer');
    //             const res = await saveDocumentAsQuotation(formData);
    //             console.log(res , 'response for proposer')
    //             return res;
    //         } catch (error) {
    //             console.error("Error in save document quotation:", error);
    //         }
    //     };

    const handlePincodeChange = async (event) => {
        // const pincode = event.target.value;
        const pincode = event.target.value.replace(/^\s+|\s+$/g, ""); // Remove leading & trailing spaces
        await setValue("proposer_pin_code", pincode);
        await trigger("proposer_pin_code");
        if (pincode.length === 6) {
            fetchPincodeDetails(pincode);
        } else {
            setStateDetails({});
            setCityDetails({});
        }
    };

    const fetchPincodeDetails = async (pincode) => {
        try {
            const clientConifig = await getClientConfig({ company_id: companyId, name: COMPANY_MASTER_PINCODE });
            const clientKey = clientConifig?.data?.result[0]?.key;
            console.log("clientKey------>", clientKey);
            setStateDetails({ value: 0, label: "Loading..." });
            setCityDetails({ value: 0, label: "Loading..." });

            // const res = await stateCityByActivePincode(pincode);
            const res = await stateCityByActiveMasterPincode({ pincode: pincode, clientKey: clientKey });

            const pincodeData = res.data.result;
            console.log(pincodeData, "pincodeData")
            
            if (pincodeData.length> 0 && pincodeData[0].state_id && pincodeData[0].city_id) {
                const stateValue = {
                    value: pincodeData[0].state_id,
                    label: pincodeData[0].state,
                };
                // setGstnStateCode(pincodeData?.stateSchema?.state_gst_code);
                setStateDetails(stateValue);
                setValue("state", stateValue);
                trigger("state");

                 // Build city options with a default placeholder
                const cityOptionsData = [
                    { value: 0, label: "Select City", isDisabled: true },
                    ...pincodeData.map((item) => ({
                        value: item.city_id,
                        label: item.city,
                        isDisabled: false
                    })),
                ];

                setCityOptions(cityOptionsData);
                setCityDetails(cityOptionsData[0]); // Set default city to placeholder
                // console.log("cityOptions", cityOptionsData);
                // setCityDetails(cityOptionsData[0]);
                // console.log(cityDetails, "cityDetails")
                setValue("city", cityOptionsData[0]);
                trigger("city");
                const storedCity = reduxValidationData?.proposerCommonDetails?.city;

                const matchedCity = cityOptionsData.find(
                    city => city.value === storedCity?.value
                );

                if (matchedCity) {
                    setCityDetails(matchedCity);

                    setValue("city", matchedCity, {
                        shouldValidate: true,
                        shouldDirty: true,
                        shouldTouch: true,
                    });
                }

                // const cityValue = {
                //     value: pincodeData.city_id,
                //     label: pincodeData.city,
                // };
                // setCityDetails(cityValue);
                // setValue("city", cityValue);
                // trigger("city");
                
                console.log("State and city populated successfully:", stateValue, cityOptions);
            } else {
                console.error("Invalid pincode data received:", pincodeData);
                setStateDetails({ value: 0, label: "No state found" });
                setCityOptions([{ value: 0, label: "No city found", isDisabled: true }]);
                setCityDetails({ value: 0, label: "No city found" });
            }
        } catch (err) {
            console.error("Error fetching pincode details:", err);
            setStateDetails({ value: 0, label: "Invalid data" });
            setCityDetails({ value: 0, label: "Invalid data" });
        }
    };

    // Watch customer company pincode so programmatic updates reflect in the UI
    const companyPin = watch("customer_company_pin_code") || "";

    const handleCompanyPincodeChange = async (event) => {
        const pincode = event.target.value.replace(/^\s+|\s+$/g, "");
        await setValue("customer_company_pin_code", pincode);
        await trigger("customer_company_pin_code");
        if (pincode.length === 6) {
            fetchCompanyPincodeDetails(pincode);
        } else {
            setCompanyStateDetails({});
            setCompanyCityDetails({});
            // clear company state/city form values
            setValue('customer_company_state', '');
            setValue('customer_company_city', '');
        }
    };

    console.log('cityDetails', cityDetails, reduxValidationData?.proposerCommonDetails?.city)

    const fetchCompanyPincodeDetails = async (pincode) => {
        try {
            // const clientConifig = await getClientConfig({ company_id: companyId, name: COMPANY_MASTER_PINCODE });

            // const clientKey = clientConifig?.data?.result[0]?.key;
            // console.log("clientKey------>", clientKey);
            // setCompanyStateDetails({ value: 0, label: "Loading..." });
            // setCompanyCityDetails({ value: 0, label: "Loading..." });

            const res = await stateCityByPincode(pincode);
            // const res = await stateCityByActiveMasterPincode({ pincode, clientKey: clientKey });
            const pincodeData = res.data.result;
            if (pincodeData && pincodeData.state_id && pincodeData.city_id) {
                const stateValue = {
                    value: pincodeData.state_id,
                    label: pincodeData.state,
                }
                setCompanyStateDetails(stateValue);
                await setValue("customer_company_state", stateValue);
                await trigger("customer_company_state");
                const cityValue = {
                    value: pincodeData.city_id,
                    label: pincodeData.city,
                };
                setCompanyCityDetails(cityValue);
                await setValue("customer_company_city", cityValue);
                await trigger("customer_company_city");
            } else {
                setCompanyStateDetails({ value: 0, label: "No state found" });
                setCompanyCityDetails({ value: 0, label: "No city found" });
            }
        } catch (err) {
            setCompanyStateDetails({ value: 0, label: "Invalid data" });
            setCompanyCityDetails({ value: 0, label: "Invalid data" });
        }
    };

    // Handler for GST input changes extracted from JSX to keep markup clean
    const handleGstChange = async (e) => {
        const v = (e.target.value || "").trim().toUpperCase();
        setValue('customer_gstn', v);
        await trigger('customer_gstn');

        // Cancel any reduxValidationData debounce timer
        if (gstLookupTimeout.current) {
            clearTimeout(gstLookupTimeout.current);
            gstLookupTimeout.current = null;
        }

        // If user cleared the GST field, silently clear derived company fields immediately
        if (v.length === 0) {
            await setValue('customer_company_pin_code', '');
            await trigger('customer_company_pin_code');
            setCompanyStateDetails({});
            setCompanyCityDetails({});
            await setValue('customer_company_state', '');
            await trigger('customer_company_state');
            await setValue('customer_company_city', '');
            await trigger('customer_company_city');
            await setValue('customer_company_address', '');
            await trigger('customer_company_address');
            await setValue('customer_company_name', '');
            await trigger('customer_company_name');
            setIsFetching(false);
            return;
        }

        // Debounce validation/lookup: wait for typing to stop (500ms)
        const current = v;
        gstLookupTimeout.current = setTimeout(async () => {
            // If after debounce the input is empty, just return
            if (!current || current.length === 0) {
                gstLookupTimeout.current = null;
                return;
            }

            // If full GSTIN, perform lookup
            if (current.length === 15) {
                try {
                    setIsFetching(true);
                    const res = await fetchCompanyGst(current);
                    // New response format handling
                    const principalAddr = res?.branchDetails?.principalAddress?.address || '';
                    const tradeName = res?.basicDetails?.tradeName || res?.basicDetails?.legalBusinessName || '';
                    const match = principalAddr && principalAddr.match(/\b\d{6}\b/);
                    const pncd = match ? match[0] : '';
                    if (pncd) {
                        // set company pincode and resolve state/city from pincode
                        await setValue('customer_company_pin_code', pncd);
                        await setValue('customer_company_name', tradeName || '');
                        await setValue('customer_company_address', principalAddr || '');
                        await trigger('customer_company_pin_code');
                        await fetchCompanyPincodeDetails(pncd);
                    } else {
                        // clear any previous company location values and inform user
                        await setValue('customer_company_pin_code', '');
                        await trigger('customer_company_pin_code');
                        setCompanyStateDetails({});
                        setCompanyCityDetails({});
                        await setValue('customer_company_state', '');
                        await trigger('customer_company_state');
                        await setValue('customer_company_city', '');
                        await trigger('customer_company_city');
                        await setValue('customer_company_address', '');
                        await trigger('customer_company_address');
                        await setValue('customer_company_name', '');
                        await trigger('customer_company_name');
                        toast.error('GST lookup returned no principal address for the provided GSTIN');
                    }
                } catch (err) {
                    console.error('GST lookup failed', err);
                    // clear fields on error as well
                    await setValue('customer_company_pin_code', '');
                    await trigger('customer_company_pin_code');
                    setCompanyStateDetails({});
                    setCompanyCityDetails({});
                    await setValue('customer_company_state', '');
                    await trigger('customer_company_state');
                    await setValue('customer_company_city', '');
                    await trigger('customer_company_city');
                    await setValue('customer_company_address', '');
                    await trigger('customer_company_address');
                    await setValue('customer_company_name', '');
                    await trigger('customer_company_name');
                    toast.error('GST lookup failed. Please check the GSTIN and try again.');
                } finally {
                    setIsFetching(false);
                    gstLookupTimeout.current = null;
                }
            } else {
                // Not full length after typing stopped: clear derived fields and show one error
                await setValue('customer_company_pin_code', '');
                await trigger('customer_company_pin_code');
                setCompanyStateDetails({});
                setCompanyCityDetails({});
                await setValue('customer_company_state', '');
                await trigger('customer_company_state');
                await setValue('customer_company_city', '');
                await trigger('customer_company_city');
                await setValue('customer_company_address', '');
                await trigger('customer_company_address');
                await setValue('customer_company_name', '');
                await trigger('customer_company_name');
                toast.error('Invalid GSTIN length. GSTIN must be 15 characters long.');
                gstLookupTimeout.current = null;
            }
        }, 1000);
    };

 


    console.log("form",formState);
    
    // Define bulk flow steps
    const bulkSteps = [
        { name: "Select Scheme & Type" },
        { name: "Review & Upload" },
        { name: "Proposer Details" },
        { name: "Payment" },
    ];
    
    // Current step is 2 (0-indexed) - Proposer Details
    const currentBulkStep = 2;
    
    // Get user data from localStorage
    const userData = JSON.parse(localStorage.getItem("user") || "{}");

    return (
        <Fragment>
            <Card style={{ marginTop: "20px" }}>
                <CardBody className="btn-group-showcase">
                    {/* Stepper Header */}
                    <BulkDocumentStepperHeader 
                        currentStep={currentBulkStep} 
                        steps={bulkSteps} 
                        user={userData} 
                    />
                    
                    <hr style={{ marginTop: "20px", marginBottom: "20px" }}></hr>

                    <Row>
                        <Col sm="12">
                            <Form
                                className="needs-validation"
                                onSubmit={handleSubmit(handleTravellerDetails)}
                            >
                                <div className="form-row">
                                   
                            <Col md="12">
                                <div className="col-12">
                                    <Card style={{ fontFamily: "Poppins !important" }}>
                                        <CardBody className="btn-group-showcase">
                                            {/* <PlanDetails quotationNumber={quotationNumber} /> */}
                                            {/* Quotation info banner */}
                                            {reduxValidationData?.bulkQuotationNumber && (
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "16px",
                                                    border: "1px solid #00239c",
                                                    borderRadius: "8px",
                                                    padding: "8px 16px",
                                                    backgroundColor: "#f0f4ff",
                                                    marginBottom: "12px",
                                                    flexWrap: "wrap",
                                                    justifyContent: "space-between"
                                                }}>
                                                    <span style={{ fontSize: "13px", fontWeight: "bold", color: "#00239c"  }}>Quotation No.: {reduxValidationData.bulkQuotationNumber}</span>
                                                    {/* <span style={{ fontSize: "13px", fontWeight: "bold", color: "#00239c" }}></span> */}
                                                    <span style={{ color: "#ccc" }}>|</span>
                                                    <span style={{fontSize: "13px", fontWeight: "bold", color: "#00239c"  }}>Total Payable: {convertToRupees(updatedBulkTotalPremium)}</span>
                                                    
                                                </div>
                                            )}
                                            <Row style={{ marginLeft: "0px", marginTop: "30px" }} >
                                                <h6 className="mt-10"><b> {proposerFullName ? `Proposer : ${proposerFullName}` : 'Proposer Details'}</b></h6>
                                            </Row>
                                            
                                            {/* Proposer Personal Information Section */}
                                            <Row style={{ marginTop: "35px" }}>
                                                <Col md="12">
                                                    <h6><b>Personal Information</b></h6>
                                                    <hr />
                                                </Col>
                                            </Row>
                                            
                                            <Row style={{ marginTop: "35px" }}>
                                                {/* Passport Number */}
                                                <Col md="3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>{hasProposerUniqueNumber ? 'Unique No.' : 'Passport No.'}</Label>{!hasProposerUniqueNumber && <RequiredIndicator />}
                                                                <Input
                                                                    type="text"
                                                                    className="form-control digits policy-input-css placeholder-center"
                                                                    placeholder={hasProposerUniqueNumber ? 'Enter unique number' : 'Enter passport'}
                                                                    name="proposer_passport_number"
                                                                    value={passportNo || ''}
                                                                    readOnly={hasProposerUniqueNumber}
                                                                    disabled={hasProposerUniqueNumber}
                                                                    {...register('proposer_passport_number')}
                                                                    onBlur={(e) => {
                                                                        if (hasProposerUniqueNumber) return;
                                                                        const trimmed = e.target.value.trim().toUpperCase(); // Convert to uppercase
                                                                        setPassportNo(trimmed);
                                                                        setValue("proposer_passport_number", trimmed, { shouldValidate: true });
                                                                    }}
                                                                    onChange={(e) => {
                                                                        if (hasProposerUniqueNumber) return;
                                                                        let newpassportno = e.target.value.toUpperCase(); // Convert to uppercase
                                                                        setPassportNo(newpassportno);
                                                                        setValue('proposer_passport_number', newpassportno);
                                                                        trigger('proposer_passport_number');
                                                                    }}
                                                                />
                                                                {errors.proposer_passport_number && (<p className="text-danger">{errors.proposer_passport_number.message}</p>)}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                
                                                {/* Date of Birth */}
                                                <Col md="3">
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label>{"Date Of Birth"}</Label><RequiredIndicator />
                                                            <Input 
                                                                className="form-control digits policy-input-css placeholder-center"
                                                                type="date"
                                                                {...register('proposer_dob')}
                                                                name="proposer_dob"
                                                                value={proposerDob}
                                                                max={new Date().toISOString().split("T")[0]}
                                                                onChange={(e) => {
                                                                    setProposerDob(e.target.value);
                                                                    setValue('proposer_dob', e.target.value);
                                                                    trigger('proposer_dob');
                                                                }}
                                                            />
                                                            {errors.proposer_dob && <p className="text-danger">{errors.proposer_dob.message}</p>}
                                                        </div>
                                                    </div>
                                                </Col>
                                                
                                                {/* Gender */}
                                                <Col sm="3" className="col-padding">
                                                    <div style={{ textAlign: "center" }}>
                                                        <FormGroup>
                                                            <Label>Gender</Label><RequiredIndicator />
                                                            <Input
                                                                type="select"
                                                                className="form-control policy-input-css placeholder-center"
                                                                placeholder="Select Gender"
                                                                value={proposerGender}
                                                                name={`proposer_gender`}
                                                                defaultValue={getValues(`proposer_gender`) || ''}
                                                                {...register(`proposer_gender`)}
                                                                onChange={(e) => {
                                                                    setproposerGender(e.target.value);
                                                                    setValue(`proposer_gender`, e.target.value);
                                                                    trigger(`proposer_gender`);
                                                                }}
                                                            >
                                                                <option value="" defaultValue={""}>Select Gender</option>
                                                                <option value="MALE">Male</option>
                                                                <option value="FEMALE">Female</option>
                                                                <option value="OTHERS">Others</option>
                                                            </Input>
                                                            {errors.proposer_gender && (
                                                                <p className="text-danger">{errors.proposer_gender.message}</p>
                                                            )}
                                                        </FormGroup>
                                                    </div>
                                                </Col>
                                            </Row>
                                            
                                            {/* Name Fields Row */}
                                            <Row style={{ marginTop: "20px" }}>
                                                {/* Title */}
                                                <Col md="2">
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label>{"Title"}</Label>{" "}<RequiredIndicator />
                                                            <Input
                                                                className="form-control digits policy-input-css placeholder-center"
                                                                type="select"
                                                                name="proposer_title"
                                                                value={proposerTitle}
                                                                {...register("proposer_title")}
                                                                onChange={(e) => {
                                                                    setProposerTitle(e.target.value);
                                                                    setValue('proposer_title', e.target.value);
                                                                    trigger('proposer_title');
                                                                }}
                                                            >
                                                                <option value="">{'Select'}</option>
                                                                <option value="Mr">{'Mr'}</option>
                                                                <option value="Ms">{'Ms'}</option>
                                                                <option value="Mrs">{'Mrs'}</option>
                                                                <option value="Miss">{'Miss'}</option>
                                                                <option value="Dr">{'Dr'}</option>
                                                                <option value="Prof">{'Prof'}</option>
                                                                <option value="Master">{'Master'}</option>
                                                            </Input>
                                                            {errors.proposer_title && (<p className="text-danger">{errors.proposer_title.message}</p>)}
                                                        </div>
                                                    </div>
                                                </Col>
                                                
                                                {/* First Name */}
                                                <Col md="3">
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label>{"First Name"}</Label>{" "}<RequiredIndicator />
                                                            <Input
                                                                className="form-control digits policy-input-css placeholder-center"
                                                                type="text"
                                                                placeholder="First Name"
                                                                name="proposer_first_name"
                                                                value={proposerFName}
                                                                {...register("proposer_first_name")}
                                                                onBlur={(e) => {
                                                                    const trimmed = e.target.value.trim();
                                                                    setProposerFName(trimmed);
                                                                    setValue("proposer_first_name", trimmed, { shouldValidate: true });
                                                                }}
                                                                onChange={(e) => {
                                                                    setProposerFName(e.target.value);
                                                                    setValue('proposer_first_name', e.target.value);
                                                                    trigger('proposer_first_name');
                                                                }}
                                                            />
                                                            {errors.proposer_first_name && (<p className="text-danger">{errors.proposer_first_name.message}</p>)}
                                                        </div>
                                                    </div>
                                                </Col>
                                                
                                                {/* Middle Name */}
                                                <Col md="3">
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label>{"Middle Name"}</Label>{" "}
                                                            <Input
                                                                type="text"
                                                                name="proposer_middle_name"
                                                                placeholder="Middle Name"
                                                                className="form-control digits policy-input-css placeholder-center"
                                                                value={proposerMName}
                                                                {...register("proposer_middle_name")}
                                                                onBlur={(e) => {
                                                                    const trimmed = e.target.value.trim();
                                                                    setProposerMName(trimmed);
                                                                    setValue("proposer_middle_name", trimmed, { shouldValidate: true });
                                                                }}
                                                                onChange={(e) => {
                                                                    setProposerMName(e.target.value);
                                                                    setValue('proposer_middle_name', e.target.value);
                                                                    trigger('proposer_middle_name');
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                                
                                                {/* Last Name */}
                                                <Col md="3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>{"Last Name"}</Label>{" "}<RequiredIndicator />
                                                                <Input
                                                                    type="text"
                                                                    name="proposer_last_name"
                                                                    placeholder="Last Name"
                                                                    className="form-control digits policy-input-css placeholder-center"
                                                                    value={proposerLName}
                                                                    {...register("proposer_last_name")}
                                                                    onBlur={(e) => {
                                                                        const trimmed = e.target.value.trim();
                                                                        setProposerLName(trimmed);
                                                                        setValue("proposer_last_name", trimmed, { shouldValidate: true });
                                                                    }}
                                                                    onChange={(e) => {
                                                                        setProposerLName(e.target.value);
                                                                        setValue('proposer_last_name', e.target.value);
                                                                        trigger('proposer_last_name');
                                                                    }}
                                                                />
                                                                {errors.proposer_last_name && (<p className="text-danger">{errors.proposer_last_name.message}</p>)}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            
                                            {/* Address Section Header */}
                                            <Row style={{ marginTop: "35px" }}>
                                                <Col md="12">
                                                    <h6><b>Address Information</b></h6>
                                                    <hr />
                                                </Col>
                                            </Row>
                                            
                                            <Row style={{ marginTop: "35px" }}>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>{"Pincode"}</Label> <RequiredIndicator />
                                                                <Input
                                                                    type="text"
                                                                    maxLength={6}
                                                                    name="proposer_pin_code"
                                                                    defaultValue={getValues()["proposer_pin_code"]}
                                                                    className="form-control digits policy-input-css"
                                                                    placeholder=" Enter Pincode"
                                                                    {...register('proposer_pin_code')}
                                                                    onChange={handlePincodeChange}
                                                                />
                                                                {errors.proposer_pin_code && <p className="text-danger">{errors.proposer_pin_code.message}</p>}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                    <div className="valid-feedback">{"Looks good!"}</div>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>{"Country"}</Label> <RequiredIndicator />
                                                                <Input
                                                                    className="form-control digits policy-input-css"
                                                                    type="text"
                                                                    name="proposer_country"
                                                                    value={defaultCountry || "India"}
                                                                    {...register('proposer_country')}
                                                                    readOnly
                                                                />
                                                                {errors.proposer_country && <p className="text-danger">{errors.proposer_country.message}</p>}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                    <div className="valid-feedback">{"Looks good!"}</div>
                                                </Col>
                                                {(stateDetails?.label === "No state found" || cityDetails?.label === "No city found") && (
        <Col md="6" className="text-center mb-3">
            
        <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
                The entered pincode is not currently registered in our database.
                To initiate onboarding for this location, please click this button to submit a request to Head Office for pincode activation.
            </p>
                    <Button
                        color="primary"
                        size="sm"
                        onClick={() => handleRequestPincodeToHO(getValues()["proposer_pin_code"])}
                        disabled={isLoading}
                    >
                        <i className="fa fa-envelope me-2"></i>&nbsp;
                        Request HO to add this pincode
                    </Button>
                </Col>
            )}

                                                <Col md="3">
        <FormGroup>
            <div style={{ textAlign: "center" }}>
                <div>
                    <Label>{"Province/State"}</Label> <RequiredIndicator />
                    <Select
                        isOptionDisabled={(option) => option.disabled}
                        isSearchable={true}
                        placeholder={"Select State"}
                        {...register("state")}
                        value={
                            Object.keys(stateDetails).length > 0
                                ? stateDetails
                                : reduxValidationData?.successLog[0]?.proposer.state
                        }
                        
                        name="state"
                        styles={{
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: "#4433ffcf",
                                color: "#ffff",
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: "#ffff",
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: "#ffff",
                                ":hover": {
                                    color: "#ffff",
                                },
                            }),
                            control: (base) => ({
                                ...base,
                                backgroundColor: "#d3d3d3",
                                borderRadius: "25px !important",
                                height: "33px",
                                minHeight: "30px",
                            }),
                        }}
                        isDisabled={true}
                    />
                    {errors.state && <p className="text-danger">{errors.state.message}</p>}
                    {/* Show error if state not found */}
                    {/* {stateDetails?.label === "No state found" && (
                        <p className="text-danger">State is required</p>
                    )} */}
                </div>
            </div>
        </FormGroup>
        <div className="valid-feedback">{"Looks good!"}</div>
    </Col>
    
    <Col md="3">
        <FormGroup>
            <div style={{ textAlign: "center" }}>
                <div>
                    <Label>{"City/District"}</Label> <RequiredIndicator />
                    <Select
                        // isOptionDisabled={(option) => option.disabled}
                        isSearchable={true}
                        className="policy-input-css"
                        placeholder={"Select City"}
                        {...register("city")}
                        value={
                            Object.keys(cityDetails).length > 0
                                ? cityDetails
                                : reduxValidationData?.successLog[0]?.proposer.city
                        }
                        options={cityOptions}
                        name="city"
                        styles={{
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: "#4433ffcf",
                                color: "#ffff",
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: "#ffff",
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: "#ffff",
                                ":hover": {
                                    color: "#ffff",
                                },
                                                                                }),
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    backgroundColor: state.isDisabled ? "#d3d3d3" : "#e0e4f3",
                                                                                    borderRadius: "25px !important",
                                                                                    height: "33px",
                                                                                    minHeight: "30px",
                                                                                }),
                                                                                placeholder: (base, state) => ({
                                                                                    ...base,
                                                                                    color: state.isDisabled ? "#888" : "#999",
                                                                                }),
                                                                            }}
                                                                            onChange={async (selected) => {
                                                                                await setValue("city", selected, {
                                                                                    shouldValidate: true,
                                                                                    shouldDirty: true,
                                                                                    shouldTouch: true,
                                                                                });
                                                                                await trigger("city");
                                                                                await setCityDetails(selected)
                                                                            }}
                                                                            isDisabled={
                                                                                !cityOptions ||
                                                                                cityOptions.length === 0 ||
                                                                                (cityOptions.length === 1 && cityOptions[0].label === "No city found")
                                                                            }
                                                                        />
                                                                        {errors.city && <p className="text-danger">{errors.city.message}</p>}
                                                                        {/* Show error if city not found */}
                                                                        {/* {cityDetails?.label === "No city found" && (
                        <p className="text-danger">City is required</p>
                    )} */}
                                                                    </div>
                                                                </div>
                                                            </FormGroup>
                                                            <div className="valid-feedback">{"Looks good!"}</div>
                                                        </Col>
                                                        <Col md="12">
                                                            <FormGroup>
                                                                <Label>Address</Label><RequiredIndicator />
                                                                <Input
                                                                    type="text"
                                                                    className="form-control digits policy-input-css"
                                                                    placeholder=" Enter Address Line"
                                                                    name="proposer_address"
                                                                    // defaultValue={getValues()["proposer_address"]}
                                                                    defaultValue={getValues()["proposer_address"]}
                                                                    // value="address"
                                                                    {...register('proposer_address')}
                                                                    // {...register('proposer_address', {
                                                                    //     required: "Address is required",
                                                                    //     validate: (value) => value.trim() !== "" || "Address cannot be empty or spaces only"
                                                                    // })}
                                                                    maxLength={200}
                                                                    onChange={(e) => {
                                                                        // setValue('proposer_address', e.target.value);
                                                                        // trigger('proposer_address');
                                                                        const trimmedValue = e.target.value.replace(/^\s+|\s+$/g, ""); // Remove leading & trailing spaces
                                                                        setValue('proposer_address', trimmedValue);
                                                                        trigger('proposer_address');
                                                                    }}
                                                                />
                                                                {errors.proposer_address && <p className="text-danger">{errors.proposer_address.message}</p>}

                                                            </FormGroup>
                                                        </Col>

                                                        <Col md="4">
                                                            <FormGroup>
                                                                <div style={{ textAlign: "center" }}>
                                                                    <div>
                                                                        <Label>Email</Label><RequiredIndicator />
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control digits policy-input-css"
                                                                            placeholder="e.g john.doe@mail.com"
                                                                            maxLength={100}
                                                                            name="proposer_email"
                                                                            defaultValue={getValues()["proposer_email"]}
                                                                            {...register('proposer_email')}
                                                                            onChange={(e) => {
                                                                                setValue('proposer_email', e.target.value);
                                                                                trigger('proposer_email');
                                                                            }}
                                                                />
                                                                {errors.proposer_email && <p className="text-danger">{errors.proposer_email.message}</p>}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>Mobile Number</Label><RequiredIndicator />
                                                                <Input
                                                                    type="text"
                                                                    className="form-control digits policy-input-css"
                                                                    placeholder=" Enter Mobile Number"
                                                                    maxLength={10}
                                                                    name="proposer_mobile"
                                                                    defaultValue={getValues()["proposer_mobile"]}
                                                                    {...register('proposer_mobile')}
                                                                    onChange={(e) => {
                                                                        setValue('proposer_mobile', e.target.value);
                                                                        trigger('proposer_mobile');
                                                                    }}
                                                                />
                                                                {errors.proposer_mobile && <p className="text-danger">{errors.proposer_mobile.message}</p>}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="5"></Col>
                                                {/* {(policyData.generateQuote?.policyType == "18" || policyData.generateQuote?.policyType == "17") && (
                                                    <>
                                                       
                                                            <Col md="4">
                                                                <FormGroup>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <div>
                                                                            <Label>Sponsor Name</Label> <RequiredIndicator />
                                                                            <Input
                                                                                type="text"
                                                                                name="sponsor_name"
                                                                                defaultValue={getValues()["sponsor_name"]}
                                                                                className="form-control digits policy-input-css"
                                                                                placeholder=" Enter Sponsor name"
                                                                                {...register('sponsor_name')}
                                                                                onChange={(e) => setValue('sponsor_name', e.target.value)}
                                                                            />
                                                                            {errors.sponsor_name && <p className="text-danger">{errors.sponsor_name.message}</p>}
                                                                        </div>
                                                                    </div>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4">
                                                                <FormGroup>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <div>
                                                                            <Label>Sponsor Date of Birth</Label> <RequiredIndicator />
                                                                            <Input
                                                                                type="date"
                                                                                name="sponsor_dob"
                                                                                defaultValue={getValues()["sponsor_dob"]}
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                className="form-control digits policy-input-css"
                                                                                placeholder=" Enter Sponsor dob"
                                                                                {...register('sponsor_dob')}
                                                                                onChange={(e) => setValue('sponsor_dob', e.target.value)}
                                                                            />
                                                                            {errors.sponsor_dob && <p className="text-danger">{errors.sponsor_dob.message}</p>}
                                                                        </div>
                                                                    </div>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4">
                                                                <FormGroup>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <div>
                                                                            <Label>Sponsor Relation</Label> <RequiredIndicator />
                                                                            <select
                                                                                name="sponsor_proposer_relation"
                                                                                className="form-control digits policy-input-css"
                                                                                defaultValue={getValues()["sponsor_proposer_relation"]}
                                                                                {...register('sponsor_proposer_relation')}
                                                                                onChange={(e) => setValue('sponsor_proposer_relation', e.target.value)}
                                                                            >
                                                                                <option value=""> Select Relation</option>
                                                                                {relationOptions.map((relation, index) => (
                                                                                    <option key={index} value={relation.value}>
                                                                                        {relation.label}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                            {errors.sponsor_proposer_relation && <p className="text-danger">{errors.sponsor_proposer_relation.message}</p>}
                                                                        </div>
                                                                    </div>
                                                                </FormGroup>
                                                            </Col>
                                                       
                                                        
                                                            <Col md="4">
                                                                <FormGroup>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <div>
                                                                            <Label>University Name</Label> <RequiredIndicator />
                                                                            <Input
                                                                                type="text"
                                                                                name="university_name"
                                                                                defaultValue={getValues()["university_name"]}
                                                                                className="form-control digits policy-input-css"
                                                                                placeholder=" Enter university name"
                                                                                {...register('university_name')}
                                                                                onChange={(e) => setValue('university_name', e.target.value)}
                                                                            />
                                                                            {errors.university_name && <p className="text-danger">{errors.university_name.message}</p>}
                                                                        </div>
                                                                    </div>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4">
                                                                <FormGroup>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <div>
                                                                            <Label>University Address</Label> <RequiredIndicator />
                                                                            <Input
                                                                                type="text"
                                                                                name="university_address"
                                                                                defaultValue={getValues()["university_address"]}
                                                                                className="form-control digits policy-input-css"
                                                                                placeholder=" Enter university address"
                                                                                {...register('university_address')}
                                                                                onChange={(e) => setValue('university_address', e.target.value)}
                                                                            />
                                                                            {errors.university_address && <p className="text-danger">{errors.university_address.message}</p>}
                                                                        </div>
                                                                    </div>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4">
                                                                <FormGroup>
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <div>
                                                                            <Label>Course Details</Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="course_details"
                                                                                defaultValue={getValues()["course_details"]}
                                                                                className="form-control digits policy-input-css"
                                                                                placeholder=" Enter course details"
                                                                                {...register('course_details')}
                                                                                onChange={(e) => setValue('course_details', e.target.value)}
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                </FormGroup>
                                                            </Col>
                                                        
                                                    </>
                                                )} */}
                                            
                                                {/* {policyData?.generateQuote?.plan_coi >= 50000 && !isTataAigCompany && (
                                                <>  
                                                    <Col md="3">
                                                <FormGroup>
                                                    <Label>PAN</Label><RequiredIndicator />
                                                    <Input
                                                        label="PAN"
                                                        type="text"
                                                        className="form-control digits policy-input-css"
                                                        placeholder=" Enter PAN"
                                                        maxLength={10}
                                                        name="proposer_pan"
                                                        defaultValue={getValues()['proposer_pan'] || "AABCE7775Q"}
                                                        {...register('proposer_pan')}
                                                        // onChange={(e) => {
                                                        //     setValue('proposer_pan', e.target.value);
                                                        //     trigger('proposer_pan');
                                                        // }}
                                                        disabled={true}
                                                    />
                                                    {errors.proposer_pan && <p className="text-danger">{errors.proposer_pan.message}</p>}
                                                </FormGroup>
                                            </Col>
                                                </>
                                            )} */}

                                            {isGSTReg ? (
                                                <>
                                                    {/* Invoice To Self */}
                                                    {partnershipType !== EAI_PARTNER && !isRo && (
                                                    <Col md="12" className="mt-3">
                                                        <FormGroup check>
                                                            <Input
                                                                type="checkbox"
                                                                id="invoiceToSelf"
                                                                checked={!isCustomerInvoice}
                                                                onChange={async (e) => {
                                                                    const c = e.target.checked;
                                                                    if (c) {
                                                                        // Select Self
                                                                        setCustomerInvoice(false);
                                                                        setValue('isCustomerInvoice', false);
                                                                        setGstDetails(false);
                                                                        setValue('isGSTN', false);
                                                                        await trigger('isCustomerInvoice');
                                                                        await trigger('isGSTN');
                                                                    } else {
                                                                        // If unchecking self, switch to customer
                                                                        setCustomerInvoice(true);
                                                                        setValue('isCustomerInvoice', true);
                                                                        setGstDetails(false);
                                                                        setValue('isGSTN', false);
                                                                        await trigger('isCustomerInvoice');
                                                                        await trigger('isGSTN');
                                                                    }
                                                                    // Clear nested GST/company fields
                                                                    await setValue('customer_gstn', '');
                                                                    await trigger('customer_gstn');
                                                                    await setValue('customer_company_pin_code', '');
                                                                    await trigger('customer_company_pin_code');
                                                                    setCompanyStateDetails({});
                                                                    setCompanyCityDetails({});
                                                                    await setValue('customer_company_state', '');
                                                                    await trigger('customer_company_state');
                                                                    await setValue('customer_company_city', '');
                                                                    await trigger('customer_company_city');
                                                                }}
                                                            />
                                                            <Label check for="invoiceToSelf">
                                                                <b>Invoice To Self</b>
                                                            </Label>
                                                        </FormGroup>
                                                    </Col>)}

                                                    {/* Invoice To Customer with nested GST toggle */}
                                                    <Col md="12" className="mt-3">
                                                        <FormGroup check>
                                                            <Input
                                                                type="checkbox"
                                                                id="invoiceToCustomer"
                                                                disabled={isRo || partnershipType === EAI_PARTNER}
                                                                checked={isCustomerInvoice}
                                                                onChange={async (e) => {
                                                                    const c = e.target.checked;
                                                                    if (c) {
                                                                        // Select Customer
                                                                        setCustomerInvoice(true);
                                                                        setValue('isCustomerInvoice', true);
                                                                        // default: GST usage off until inner toggled
                                                                        setGstDetails(false);
                                                                        setValue('isGSTN', false);
                                                                        await trigger('isCustomerInvoice');
                                                                        await trigger('isGSTN');
                                                                    } else {
                                                                        // Switch to Self
                                                                        setCustomerInvoice(false);
                                                                        setValue('isCustomerInvoice', false);
                                                                        setGstDetails(false);
                                                                        setValue('isGSTN', false);
                                                                        await trigger('isCustomerInvoice');
                                                                        await trigger('isGSTN');
                                                                        // Clear nested GST/company fields
                                                                        await setValue('customer_gstn', '');
                                                                        await trigger('customer_gstn');
                                                                        await setValue('customer_company_pin_code', '');
                                                                        await trigger('customer_company_pin_code');
                                                                        setCompanyStateDetails({});
                                                                        setCompanyCityDetails({});
                                                                        await setValue('customer_company_state', '');
                                                                        await trigger('customer_company_state');
                                                                        await setValue('customer_company_city', '');
                                                                        await trigger('customer_company_city');
                                                                    }
                                                                }}
                                                            />
                                                            <Label check for="invoiceToCustomer">
                                                                <b>Invoice To Customer</b>
                                                                
                                                            </Label>

                                                            {/* Inner GST usage toggle appears only when invoicing to customer */}
                                                            {isCustomerInvoice && (
                                                                <div style={{ marginTop: 8, paddingLeft: 18 }}>
                                                                    <FormGroup check>
                                                                        <Input
                                                                            type="checkbox"
                                                                            id="useGstinBooking"
                                                                            checked={isGstDetails}
                                                                            onChange={async (e) => {
                                                                                const v = e.target.checked;
                                                                                setGstDetails(v);
                                                                                setValue('isGSTN', v);
                                                                                await trigger('isGSTN');
                                                                                if (!v) {
                                                                                    // Clear nested GST/company fields when GST usage turned off
                                                                                    await setValue('customer_gstn', '');
                                                                                    await trigger('customer_gstn');
                                                                                    await setValue('customer_company_pin_code', '');
                                                                                    await trigger('customer_company_pin_code');
                                                                                    setCompanyStateDetails({});
                                                                                    setCompanyCityDetails({});
                                                                                    await setValue('customer_company_state', '');
                                                                                    await trigger('customer_company_state');
                                                                                    await setValue('customer_company_city', '');
                                                                                    await trigger('customer_company_city');
                                                                                }
                                                                            }}
                                                                        />
                                                                        <Label check for="useGstinBooking">
                                                                            <b>GST Customer</b>
                                                                            <p style={{ marginBottom: 0 }}>Information entered here will reflect in the Invoice</p>
                                                                        </Label>
                                                                    </FormGroup>
                                                                </div>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                </>
                                            ) : (
                                                <>
                                                    {/* Non-GST: Invoice to customer locked, GST usage optional */}
                                                    <Col md="12" className="mt-3">
                                                        <FormGroup check>
                                                            <Input type="checkbox" id="invoiceToCustomerLocked" checked={true} disabled={true} />
                                                            <Label check for="invoiceToCustomerLocked">
                                                                <b>Invoice To Customer</b>
                                                              
                                                            </Label>

                                                            <div style={{ marginTop: 8, paddingLeft: 18 }}>
                                                                <FormGroup check>
                                                                    <Input
                                                                        type="checkbox"
                                                                        id="useGstinBooking"
                                                                        checked={isGstDetails}
                                                                        onChange={async (e) => {
                                                                            const v = e.target.checked;
                                                                            setGstDetails(v);
                                                                            setValue('isGSTN', v);
                                                                            // Always invoice to customer for non-GST partners
                                                                            setCustomerInvoice(true);
                                                                            setValue('isCustomerInvoice', true);
                                                                            await trigger('isCustomerInvoice');
                                                                            await trigger('isGSTN');
                                                                            if (!v) {
                                                                                await setValue('customer_gstn', '');
                                                                                await trigger('customer_gstn');
                                                                                await setValue('customer_company_pin_code', '');
                                                                                await trigger('customer_company_pin_code');
                                                                                setCompanyStateDetails({});
                                                                                setCompanyCityDetails({});
                                                                                await setValue('customer_company_state', '');
                                                                                await trigger('customer_company_state');
                                                                                await setValue('customer_company_city', '');
                                                                                await trigger('customer_company_city');
                                                                            }
                                                                        }}
                                                                    />
                                                                    <Label check for="useGstinBooking">
                                                                        <b>GST Customer</b>
                                                                        <p style={{ marginBottom: 0 }}>Information entered here will reflect in the Invoice</p>
                                                                    </Label>
                                                                </FormGroup>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </>
                                            )}
                                                {isGstDetails && <Col md="4" className="mt-3"> 
                                                    <FormGroup>
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label for="GSTN">GST (Traveller GST only)</Label><RequiredIndicator />
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <Input
                                                                    type="text"
                                                                    className="form-control digits policy-input-css"
                                                                    placeholder="Enter GST"
                                                                    name="customer_gstn"
                                                                    value={watch('customer_gstn') || ''}
                                                                    {...register('customer_gstn')}
                                                                    onChange={handleGstChange}
                                                                />
                                                                {isFetching && (
                                                                    <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                                                )}
                                                            </div>
                                                            {errors.customer_gstn && <p className="text-danger">{errors.customer_gstn.message}</p>}
                                                        </div>
                                                    </div>
                                                    </FormGroup> 
                                                </Col>
                                                }
                                                 {isGstDetails && <Col md="4" className="mt-3"> 
                                                    <FormGroup>
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label for="GSTN">Company Pincode</Label><RequiredIndicator />
                                                            <Input
                                                                type="text"
                                                            className="form-control digits policy-input-css"
                                                                placeholder="Enter Company Pincode"
                                                                name="customer_company_pin_code"
                                                                value={companyPin}
                                                                {...register('customer_company_pin_code')}
                                                                disabled={true}
                                                            />
                                                            {errors.customer_company_pin_code && <p className="text-danger">{errors.customer_company_pin_code.message}</p>}
                                                        </div>
                                                    </div>
                                                    </FormGroup> 
                                                </Col>
                                                }
                                                {isGstDetails && <Col md="4" className="mt-3"> 
                                                    <FormGroup>
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <Label for="GSTN">Company Name</Label><RequiredIndicator />
                                                            <Input
                                                                type="text"
                                                            className="form-control digits policy-input-css"
                                                                placeholder="Enter Company Name"
                                                                name="customer_company_name"
                                                                value={watch('customer_company_name') || ''}
                                                                {...register('customer_company_name')}
                                                                onChange={(e) => {
                                                                    setValue('customer_company_name', e.target.value);
                                                                    trigger('customer_company_name');
                                                                }}
                                                            />
                                                            {errors.customer_company_name && <p className="text-danger">{errors.customer_company_name.message}</p>}
                                                        </div>
                                                    </div>
                                                    </FormGroup> 
                                                </Col>
                                                }
                                               
                                                {isGstDetails &&
                                                    <>
                                                        <Col md="3" className="mt-3">
                                                            <FormGroup>
                                                                <div style={{ textAlign: "center" }}>
                                                                    <div>
                                                                        <Label>Company Country</Label> <RequiredIndicator />
                                                                        <Input
                                                                            className="form-control digits policy-input-css"
                                                                            type="text"
                                                                            name="customer_company_country"
                                                                            value={defaultCountry || "India"}
                                                                            {...register('customer_company_country')}
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3" className="mt-3">
                                                            <FormGroup>
                                                                <div style={{ textAlign: "center" }}>
                                                                    <div>
                                                                        <Label>Company Province/State</Label> <RequiredIndicator />
                                                                        <Select
                                                                            isOptionDisabled={(option) => option.disabled}
                                                                            isSearchable={true}
                                                                            placeholder={"Company State"}
                                                                            {...register("customer_company_state")}
                                                                            value={
                                                                                Object.keys(companyStateDetails).length > 0
                                                                                    ? companyStateDetails
                                                                                    : (reduxValidationData?.successLog[0]?.proposer?.customer_company_state || null)
                                                                            }
                                                                            name="customer_company_state"
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    backgroundColor: "#d3d3d3",
                                                                                    borderRadius: "25px !important",
                                                                                    height: "33px",
                                                                                    minHeight: "30px",
                                                                                }),
                                                                            }}
                                                                            isDisabled={true}
                                                                        />
                                                                        {errors.customer_company_state && <p className="text-danger">{errors.customer_company_state.message}</p>}
                                                                    </div>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3" className="mt-3">
                                                            <FormGroup>
                                                                <div style={{ textAlign: "center" }}>
                                                                    <div>
                                                                        <Label>Company City/District</Label> <RequiredIndicator />
                                                                        <Select
                                                                            isOptionDisabled={(option) => option.disabled}
                                                                            isSearchable={true}
                                                                            placeholder={"Company City"}
                                                                            {...register("customer_company_city")}
                                                                            value={
                                                                                Object.keys(companyCityDetails).length > 0
                                                                                    ? companyCityDetails
                                                                                    : (reduxValidationData?.successLog[0]?.proposer?.customer_company_city || null)
                                                                            }
                                                                            name="customer_company_city"
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    backgroundColor: "#d3d3d3",
                                                                                    borderRadius: "25px !important",
                                                                                    height: "33px",
                                                                                    minHeight: "30px",
                                                                                }),
                                                                            }}
                                                                            isDisabled={true}
                                                                        />
                                                                        {errors.customer_company_city && <p className="text-danger">{errors.customer_company_city.message}</p>}
                                                                    </div>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                    </>
                                                }
                                                {isGstDetails &&
                                                (
                                                    <>
                                                 <Col md="12" mt="3">
                                                    <FormGroup>
                                                        <Label>Address</Label><RequiredIndicator />
                                                        <Input
                                                            type="text"
                                                            className="form-control digits policy-input-css"
                                                            placeholder=" Enter Address Line"
                                                            name="customer_company_address"
                                                            defaultValue={getValues()["customer_company_address"]}
                                                            {...register('customer_company_address')}
                                                            maxLength={200}
                                                            onChange={(e) => {
                                                            const trimmedValue = e.target.value.replace(/^\s+|\s+$/g, ""); // Remove leading & trailing spaces
                                                            setValue('customer_company_address', trimmedValue);
                                                            trigger('customer_company_address');
                                                        }}
                                                    />
                                                      {errors.customer_company_address && <p className="text-danger">{errors.customer_company_address.message}</p>}
 
                                                    </FormGroup>
                                                 </Col>
                                                 {/* <Col md="4" className="mt-3">
                                                 </Col> */}
                                                    </>
                                                )
                                                }
                                                {isGstDetails && <Col md="4" className="mt-3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>Mobile Number</Label><RequiredIndicator />
                                                                <Input
                                                                    type="text"
                                                                    className="form-control digits policy-input-css"
                                                                    placeholder=" Enter Mobile Number"
                                                                    maxLength={10}
                                                                    name="customer_mobile"
                                                                    value={watch('customer_mobile') || ''}
                                                                    {...register('customer_mobile')}
                                                                    onChange={(e) => {
                                                                        setValue('customer_mobile', e.target.value);
                                                                        trigger('customer_mobile');
                                                                    }}
                                                                />
                                                                {errors.customer_mobile && <p className="text-danger">{errors.customer_mobile.message}</p>}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>}
                                                 {isGstDetails && <Col md="4" className="mt-3">
                                                    <FormGroup>
                                                        <div style={{ textAlign: "center" }}>
                                                            <div>
                                                                <Label>Email</Label><RequiredIndicator />
                                                                <Input
                                                                    type="text"
                                                                    className="form-control digits policy-input-css"
                                                                    placeholder="e.g john.doe@mail.com"
                                                                    maxLength={100}
                                                                    name="customer_email"
                                                                    value={watch('customer_email') || ''}
                                                                    {...register('customer_email')}
                                                                    onChange={(e) => {
                                                                        setValue('customer_email', e.target.value);
                                                                        trigger('customer_email');
                                                                    }}
                                                                />
                                                                {errors.customer_email && <p className="text-danger">{errors.customer_email.message}</p>}
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>}
                                                
                                                {/* <Col md="3">
                                                <FormGroup>
                                                    <Label for="GSTN">GST</Label><RequiredIndicator />
                                                    <Input
                                                        type="text"
                                                       className="form-control digits policy-input-css"
                                                        placeholder="Enter GST"
                                                        name="proposer_gstn"
                                                        {...register('proposer_gstn')}
                                                        onChange={(e) => {
                                                            setValue('proposer_gstn', e.target.value);
                                                            trigger('proposer_gstn');
                                                        }}
                                                    />
                                                    {errors.proposer_gstn && <p className="text-danger">{errors.proposer_gstn.message}</p>}
                                                </FormGroup>
                                            </Col> */}
                                           
                                                
                                            </Row>
                                            <div className="d-flex justify-content-between btn-mt">
                                                <Button
                                                    color="warning"
                                                    className="px-4 rounded-pill stepper-back-btn"
                                                    onClick={handleBackClick}
                                                >
                                                    <span className="mr-2">{"<"}</span> Back
                                                </Button>
                                                {/* <div>
                                                    {isFetching ? (
                                                        "Sending..."
                                                    ) : (
                                                        <span onClick={() => shareQuotationDetails()} style={{ cursor: 'pointer', color: '#25D366', marginLeft: "488%",  display: 'flex', alignItems: 'center', marginTop: "8px" }}>
                                                            <i className="fa fa-whatsapp" style={{ marginRight: '5px', color: '#25D366' }}></i>
                                                            {"Share"}
                                                        </span>
                                                    )}
                                                </div> */}
                                                <Button
                                                    color="primary"
                                                    type="submit"
                                                    className="px-4 rounded-pill stepper-next-btn"
                                                >
                                                    {isLoading ? "Loading..." : (<span>{"Next"} <span className="ml-2">{">"}</span></span>)}
                                                </Button>
                                                {/* </Col> */}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </Col>
                        </div>

                    </Form>
                </Col>
            </Row>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default TravellerNewDetails;